import { render, staticRenderFns } from "./StudentPickerAutocomplete.vue?vue&type=template&id=4ba0f71f&scoped=true&"
import script from "./StudentPickerAutocomplete.vue?vue&type=script&lang=js&"
export * from "./StudentPickerAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba0f71f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/Dan/code/teacher-helper/teacher-helper/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
installComponents(component, {VAutocomplete})
